const servicesRowStyle = () => ({
	servicesRow: {
		'& .wrapper': {
			textTransform: 'capitalize',
		},
	},
	nameWrapper: {
		paddingRight: 10,
	},
});

export default servicesRowStyle;
